import { engine } from "../../../libs/animejs";

(function () {
	engine.fps = 60;
	engine.timeUnit = "ms";
	engine.speed = 1;
	// engine.precision = 4;
	engine.pauseOnDocumentHidden = true;
	engine.useDefaultMainLoop = true;
})();
